import axios from "axios";

const state = {
    adminToken: localStorage.getItem('admin-token') || null
};

const mutations = {
    setToken(state, token) {
        localStorage.setItem('admin-token', token);
        state.adminToken = token;
    },
    deleteToken(state) {
        localStorage.removeItem('admin-token');
        state.adminToken = null;
    },
    getToken(state) {
        return state.adminToken;
    }
};

const actions = {
    requestToken(context, credentials) {
        return new Promise((resolve, reject) => {
            axios.post('https://api.lockquest.fr/token', credentials, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((response) => {
                context.commit('setToken', response.data);
                resolve();
            }).catch((error) => {
                reject(error.response.data);
            });
        });
    },
    deleteToken(context) {
        return new Promise((resolve) => {
            context.commit('deleteToken');
            resolve();
        });
    },
    getToken(context) {
        return new Promise((resolve) => {
            var token = context.commit('getToken');
            resolve(token);
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};